import {Typography} from "@mui/material";
import useExtendLecture from "../../../../../hooks/useExtendLecture";
import LectureDto from "../../../../../interfaces/lecture/LectureDto";
import {EnumExpressionAllByTag, EnumExpressionsText} from "../../../../../utils/enum/EnumExpressions";
import EnumLectureState from "../../../../../utils/enum/EnumLectureState";
import LectureNumParams from "../../../../../utils/LectureNumParams";
import {isLectureLive} from "../../../../../utils/Utils";
import DialogYesNo from "../../../../shared/dialog-yes-no/DialogYesNo";
import RemoteItem from "./RemoteItem";
import RemoteService, {RemoteServiceExport} from "./RemoteService";

interface RemoteProps {
    lecture: LectureDto;
    currentSlide: number;
    setCurrentSlide: (val: number) => void;
}

const msgCreatedLecture = "Please wait for the teacher to start the lecture";
const msgEndLecture = "The lecture is not live so you cannot provide feedback at the moment. Please choose the Q&A option if you would like to post a question/answer or enter discussions.";
export default function Remote({lecture, currentSlide, setCurrentSlide}: RemoteProps) {
    const {
        expressionData,
        expressionState,
        handleExpressionClick,
        isTeacher,
        expressionSettings,
        countOfAttendees
    }: RemoteServiceExport = RemoteService({lecture, setCurrentSlide});
    const lectureNum = LectureNumParams();
    const {showDialog, setShowDialog, confirmActionFunc, rejectActionFunc} = useExtendLecture({lectureNum});
    const displayText = (text: string) => (
        <Typography variant="h6" textAlign="center">
            {text}
        </Typography>
    );
    const createRemoteItem = (expressionTag: EnumExpressionsText) => {
        const {tagLabel} = EnumExpressionAllByTag[expressionTag];
        let percentToNotify = -1;
        if (isTeacher && expressionSettings && expressionSettings.useFeedbackNotifications) {
            if (expressionTag === EnumExpressionsText.LOST) {
                percentToNotify = expressionSettings.lost;
            } else if (expressionTag === EnumExpressionsText.NOT_CLEAR) {
                percentToNotify = expressionSettings.notClear;
            } else if (expressionTag === EnumExpressionsText.GREAT) {
                percentToNotify = expressionSettings.great;
            } else if (expressionTag === EnumExpressionsText.TOO_SIMPLE) {
                percentToNotify = expressionSettings.tooSimple;
            } else if (expressionTag === EnumExpressionsText.TOO_HARD) {
                percentToNotify = expressionSettings.tooHard;
            }
        }
        return <RemoteItem expressionData={expressionData} onClick={handleExpressionClick}
                           expressionState={expressionState} expressionTag={expressionTag} expressionLabel={tagLabel}
                           percentToNotify={percentToNotify} countOfAttendees={countOfAttendees}/>;
    };

    return (
        <div className="remote">
            {lecture.state === EnumLectureState.CREATED && displayText(msgCreatedLecture)}
            {(lecture.state === EnumLectureState.ENDED || !isLectureLive(lecture)) && displayText(msgEndLecture)}
            {lecture.state === EnumLectureState.STARTED && isLectureLive(lecture) && (
                <>
                    <div className="remote__boxShadow">
                        <div className="remote__container">
                            <div className="remote__column">
                                <div className="remote-item"></div>
                                {createRemoteItem(EnumExpressionsText.TOO_HARD)}
                                <div className="remote-item"></div>
                            </div>
                            <div className="remote__column" style={{marginTop: "-1px", paddingBottom: "15px"}}>
                                {createRemoteItem(EnumExpressionsText.LOST)}
                                {createRemoteItem(EnumExpressionsText.NOT_CLEAR)}
                                {createRemoteItem(EnumExpressionsText.GREAT)}
                            </div>
                            <div className="remote__column">
                                <div className="remote-item"></div>
                                {createRemoteItem(EnumExpressionsText.TOO_SIMPLE)}
                                <div className="remote-item"></div>
                            </div>
                        </div>
                        {currentSlide > 0 && !isTeacher &&
                            <div className="remote__title mt-2">Your feedback on slide {currentSlide}</div>}
                    </div>
                </>
            )}
            <DialogYesNo dialogData={showDialog} setDialogData={setShowDialog} confirmAction={confirmActionFunc}
                         rejectAction={rejectActionFunc}/>
        </div>
    );
}
